export default "__VITE_PUBLIC_ASSET__1bc63062__"